export const PUBLIC_SHARING_GROUP_VALUE = 'public';
